<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" class="count-result" :close-on-click-modal="false" append-to-body width="920px">
    <div slot="title" class="title">
      <div class="title-name">提示</div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
    </div>
    <div class="count-result-box">
      <div class="left-box">
        <p class="title-text">方式一（小程序转发）</p>
        <div v-if="imageUrl" class="image-box mb10">
          <img :src="imageUrl" alt="">
        </div>
        <p class="mb10">使用方法</p>
        <p class="mb10">step1</p>
        <p class="mb10">使用微信扫描小程序码</p>
        <p class="mb10">step2</p>
        <p class="mb10">点击右上角…转发给客户</p>
      </div>
      <div class="middle-box"></div>
      <div class="right-box">
        <p class="title-text">方式二（邮件版）</p>
        <div v-if="imageUrl" class="image-box mb10">
          <img :src="imageUrl" alt="">
        </div>
        <div v-if="imageUrl" class="btn-box">
          <el-button class="mr10" style="flex: none" size="mini" type="primary" @click="downloadQr">下载二维码</el-button>
          <el-button v-if="md5" class="mr10" style="flex: none" size="mini" type="primary" @click="downloadFile">下载附件</el-button>
        </div>
        <pre>{{ text }}</pre>
        <div class="btn-box">
          <el-button class="mr10" style="flex: none" size="mini" type="primary" @click="copy">复制文字</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import copyToClipboard from 'copy-to-clipboard'

const dateFormat = require('dateformat')

const { download } = require('../../project/src/constant/utils')

export default {
  data() {
    return {
      dialogVisible: false,
      imageUrl: '',
      countResult:{},
      index:0,
      md5: '',
    }
  },
  computed:{
    dateformat(){
      return dateFormat
    },
    text(){
      const { countResult } = this
      return `Dear：
       您好！年底我们整理了过往合作的数据供您和贵司参考。
       在${countResult.年份}年中，我们合作了超过${countResult.职位数}个职位，累计推荐了${countResult.推荐}位候选人，其中面试达到${countResult.面试}人次，推荐到面试的转化率大于${countResult.推荐转换为面试率}，目前为止，终面人数为${countResult.终面}，offer人数为${countResult.offer}。具体数据详见附件。其中零职位没有反馈，且反馈速度和面试效率均高于市场平均水平，被评为顾问最愿意服务的战略合作伙伴。

       感恩您一路以来的支持和信任！未来阿尔法会与您一路同行，持续给予最优质的推荐和服务，为贵司提供人力资本超额收益！

                                      阿尔法咨询`
    },
  },
  methods: {
    open(yearReport) {
      this.dialogVisible = true
      this.imageUrl = ''
      this.countResult = yearReport
      this.md5 = ''
      this.getQrCode(yearReport._id)
      this.commendatoryClientCompanyCount(yearReport)
    },
    async getQrCode(id){
      try {
        const { data } = await this.$axios.get(`https://www.yuanshouhr.com/api/salaryNew/getMpCode?scene=${id}&path=pages/summary/main`)
        this.imageUrl = data.data.code
      } catch (e) {
        return false
      }
    },
    async downloadFile(){
      download({ md5: this.md5 })
    },
    async commendatoryClientCompanyCount(yearReport){
      try {
        const res = await app.service('project').commendatoryClientCompanyCountWithData(yearReport)
        if (res && res.status === 'success' && res.data) {
          this.md5 = res.data.md5
        } else this.$message.error(res.msg)
      } catch (e) {
        console.error(e)
        this.$message.error(`生成项目搜索进度报告出错`)
      }
    },
    downloadQr(){
      const a = document.createElement('a')
      a.href = this.imageUrl
      a.download = `年度回顾报告版-${this.countResult.公司}.png`
      a.dispatchEvent(new MouseEvent('click'))
      this.$message.success('下载成功')
    },
    copy(){
      try {
        copyToClipboard(this.text)
        this.$message.success('复制成功')
      } catch (e) {
        console.log(e.message);
      }
    },
  },
}
</script>
<style>
.custom-dialog .el-dialog__body {
  padding-top: 0px;
}
.count-result-box .el-button--primary  {
  background-color: #4394b9;
  border-color: #4394b9;
}
</style>
<style scoped src="../../company/statistics/css/commonCompany.css"></style>
<style scoped>
.title-text{
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height:1.5;
  margin: 0;
  padding:15px
}
.title-btn {
  margin-left: 30px;
  color: #cbcbcb;
  font-size: 14px;
  cursor: pointer;
}
.count-result-footer{
  display: flex;
  justify-content: center;
}
.image-box{
  display: flex;
  justify-content: center;
}
.image-box img{
  width: 200px;
  height: 200px;
}
.count-result-box{
  display: flex;
  align-items: center;
  height: 600px;
}
.left-box{
  align-self: baseline;
  height: 100%;
  flex: 4;
  padding: 0 40px;
}
.middle-box{
  flex: none;
  width: 1px;
  height: 80%;
  border-right: 2px dashed #000;
}
.right-box{
  height: 100%;
  flex: 6;
  padding: 0 40px;
}
.btn-box{
  display: flex;
  justify-content: center;
}

</style>
